<template>
  <div class="content_wrapper" ref="save">
     <agent-info></agent-info>
    <div class="contract_content" >
      <contract-form-sidebar/>
      <div class="right_container p-4">
        <h3 class="mb-0 pb-2">Agreement & Signature</h3>
        <div class="description mt-2">
          <div class="mb-1">
                  <div class="contract_agreement" id="contract">
                    <h5>
                      <b>Independent Marketer Agreement</b>
                    </h5>
                    <p class="intro agreement-intro">
                      This Independent Marketer Agreement is by and
                      between Nu Era Benefits Agency and
                      <input
                        type="text"
                        name="rep"
                        ref="rep"
                        :readonly="formFields.initial.read_only"
                        v-model="formFields.initial.value" 
                        required
                        @input="resetErrors('initial')"
                      />
                      <small class="error_message" v-if="formErrorFlag == true">{{formErrors['initial']}}</small>
                      Independent Marketer, located/residing at
                      <input
                        type="text"
                        name="location"
                        :readonly="formFields.marketer_address.read_only"
                        v-model="formFields.marketer_address.value" 
                        @input="resetErrors('marketer_address')"
                      />
                      <small class="error_message" v-if="formErrorFlag == true">{{formErrors['marketer_address']}}</small>
                    </p>
                    <br />
                    <p class="initial ms-0">
                        <b>
                        <span class="ms-2">EFFECTIVE DATE: </span> 
                      </b>
                          The effective date of this Agreement shall be
                          <input
                            type="text"
                            name="effective_date"
                            :readonly="formFields.aggrement_eff_date.read_only"
                            v-model="formFields.aggrement_eff_date.value" 
                            @input="resetErrors('aggrement_eff_date')"
                          />
                          <small class="error_message" v-if="formErrorFlag == true">{{formErrors['aggrement_eff_date']}}</small>
                        </p>
                    <ol class="list">
                     
                  
                      <b>
                        <li>TERM</li> </b
                      >
                      <p>
                        This Agreement shall commence on the Effective Date stated in Paragraph I herein above and shall terminate two (2) years from the Effective Date.  
                        This Agreement shall automatically renew, unless terminated in accordance with Paragraph VI herein below.
                      </p>
                      <b>
                        <li>AUTHORIZED SERVICES PROVIDED BY INDEPENDENT MARKETER</li> </b
                      >
                      <ol type="a">
                        <br />
                        <li>
                          Nu Era Benefits Agency authorizes INDEPENDENT MARKETER to solicit, procure, verify and transmit insurance applications 
                          to contracted insurance carriers and to perform such other functions as may reasonably be required.
                        </li>
                        <br />
                        <li>
                          INDEPENDENT MARKETER is not authorized on behalf of Nu Era Benefits Agency or its contracted carriers to: incur any liability; 
                          make, waive, alter, endorse or discharge contracts or any terms thereof; bind any application for, or policy of, insurance; 
                          endorse checks payable; deliver any policy; extend the time for any payment of monthly rate; waive forfeitures; name special rates; 
                          or bind Nu Era Benefits Agency to any contract, in any way.  Unless authorized in writing, INDEPENDENT MARKETER shall not collect any monies due, 
                          or to become due, except for the collection of the initial monthly premium required by
                          the insurance carrier.
                        </li>
                        <br />
                        <li>
                          INDEPENDENT MARKETER is an independent contractor for all purposes and not an employee of Nu Era Benefits Agency.  
                          INDEPENDENT MARKETER has full control of its time and the right to exercise independent judgment as to the time, 
                          place and manner of performing services, except that it shall conform with all Carrier's guidelines, Nu Era Benefits Agency's rules and regulations, 
                          as well as all federal, state and local laws, rules, regulations and ordinances, wherever applicable.
                        </li>
                        <br />
                      </ol>
                      <b>
                        <li>TERRITORY</li> </b
                      >
                      <p>
                        INDEPENDENT MARKETER shall maintain all required licenses in all jurisdictions in which he or she is selling on behalf of Nu Era Benefits Agency and shall comply 
                        with any and all applicable federal, state, or local laws, rules, regulations or ordinances affecting its operations.  All agents and/or sub agents 
                        selling any product on behalf of Nu Era Benefits Agency and compensated by INDEPENDENT MARKETER's entity shall be licensed in their resident state and shall have all 
                        non-resident licenses required by various state laws or shall not sell any product on behalf of the carrier or EWAn any state requiring the same.  
                        INDEPENDENT MARKETER does not, however, have the exclusive right to act on behalf of Nu Era Benefits Agency in said jurisdictions.  INDEPENDENT MARKETER and/or any agent 
                        compensated by INDEPENDENT MARKETER shall not be permitted to market any products on behalf of Nu Era Benefits Agency or any carrier in any state in which the agent is not licensed 
                        and appointed in accordance to federal, state and/or local law.
                      </p>

                      <b>
                        <li>SUB-MARKETERS</li> </b
                      >
                      <ol type="a">
                        <li>
                          INDEPENDENT MARKETER shall have the right to utilize sub-marketers for the purpose of marketing product on behalf of Nu Era Benefits Agency.
                        </li>
                        <li>
                          Any sub-marketer shall be held to the same standards and obligations that INDEPENDENT MARKETER has agreed to under this Agreement.
                        </li>
                        <li>
                          Commissions paid to or due sub-marketer shall be the sole responsibility of INDEPENDENT MARKETER.  If the carrier returns or charges back a premium or 
                          any portion thereof for any reason, the commissions on that premium shall be the sole responsibility of INDEPENDENT MARKETER and its sub-marketer.
                        </li>
                      </ol>
                      <br/>
                      <b>
                        <li>COMPENSATION</li> </b
                      >
                      <ol type="a">
                        <li>
                          INDEPENDENT MARKETER shall be paid commissions in accordance with the schedules set forth by Nu Era Benefits Agency, 
                          attached hereto and incorporated by reference as Schedule A, including any addendums attached and incorporated hereto.
                        </li>
                        <li>
                          The commissions shall be based on the Commission Schedule(s) attached hereto and incorporated by reference 
                          herein to be credited to INDEPENDENT MARKETER on the date the premium is received and credited by the carrier.  
                          Nu Era Benefits Agency reserves the right to change commission schedules without prior notice based upon changes in commissions paid by any carrier to Nu Era Benefits Agency
                          <ol class="sub-list">
                            <li>
                              Commissions on all business paid to by any carrier shall be paid to the INDEPENDENT MARKETER on or before five (5) workings days after Nu Era Benefits Agency receives its commissions.
                            </li>
                            <li>
                              Nu Era Benefits Agency may advance commissions to an INDEPENDENT MARKETER at its sole discretion based upon those commissions advanced to Nu Era Benefits Agency  by the carrier.
                            </li>
                          </ol>
                        </li>
                        <li>
                          If the carrier returns or charges back a premium or any portion thereof for any reason, the commissions on that premium 
                          shall be deducted from INDEPENDENT MARKETER's commissions.  Nu Era Benefits Agency may offset any debt or any percentage of such debt owed by 
                          INDEPENDENT MARKETER to Nu Era Benefits Agency against any amount owed by Nu Era Benefits Agency to the INDEPENDENT MARKETER.  The principals of the corporation 
                          shall personally guarantee repayment to Nu Era Benefits Agency of any premium charged back by the carrier.
                        </li>
                        <li>
                          If Nu Era Benefits Agency, in its discretion, finds it necessary to respond to any litigation or any dispute with any governmental 
                          Agency that arises based on the conduct of the INDEPENDENT MARKETER or any person acting on behalf of the INDEPENDENT 
                          MARKETER then INDEPENDENT MARKETER shall be responsible for one hundred percent (100%) of all attorneys fees and costs, 
                          as well as any fines assessed against Nu Era Benefits Agency.  INDEPENDENT MARKETER shall be further responsible for one hundred percent (100%) 
                          of all costs and attorney fees relating to any appeal taken from assessment of said fines.  Said fines arising from such litigation 
                          or dispute with any governmental INDEPENDENT MARKETER may be offset by present commissions earned.  If said present commissions do not 
                          totally offset fines assessed against Nu Era Benefits Agency due to INDEPENDENT MARKETER's conduct or the conduct of any person acting on behalf of INDEPENDENT MARKETER, 
                          then future commissions may be applied until such time as all applicable fines for which the INDEPENDENT MARKETER is responsible are paid in full.
                        </li>
                      </ol>                      
                      <br />
                      <b>
                        <li>TERMINATION</li> </b
                      >
                      <ol type="a">
                        <li>
                          This Agreement may be terminated at will by either party herein, by written notice of the election to terminate, delivered personally, 
                          via facsimile or mailed by first-class mail, postage pre-paid, to the other party at the last known address as stated herein above. 
                           Said termination shall be effective immediately on the date on which such termination notice is sent or mailed to the other party.
                        </li>
                        <li>
                          Nu Era Benefits Agency may terminate this Agreement, for cause, at any time and without notice, if INDEPENDENT MARKETER commits acts including, but not limited to:
                          <ol>
                            <li>
                              Failing to comply with any of the provisions of this Agreement;
                            </li>
                            <li>
                              Acts contrary to the law, or INDEPENDENT MARKETER commits a felony, act of fraud or willful misconduct in any matter related to this agreement;
                            </li>
                            <li>
                              Inducing or attempting to induce any employees, independent marketers, licensed agents, or any representatives of Nu Era Benefits Agency to discontinue their association with Nu Era Benefits Agency;
                            </li>
                            <li>
                              Inducing or attempting to induce any party to relinquish a policy or contract with Nu Era Benefits Agency.
                            </li>
                            <li>
                              Generating regulatory complaints or investigations resulting in business interruption, cease and desist orders, legal action or otherwise, in any way, damaging the or goodwill of Nu Era Benefits Agency or the reputation of Nu Era Benefits Agency products;
                            </li>
                            <li>
                              Failing to comply with any of the Carriers guidelines, Nu Era Benefits Agency’s rules, regulations or company policies or federal, state or local laws governing the industry or applicable to the terms of this Agreement;
                            </li>
                            <li>
                              Any violation relating to the replication of Nu Era Benefits Agency’s website, proprietary software or systems;
                            </li>
                          </ol>
                        </li>
                        <li>
                         This Agreement shall automatically terminate, immediately and without prior notice, upon one or more of the following: (i) the dissolution of the partnership, if the INDEPENDENT MARKETER is a partnership, (ii) the dissolution of the corporation, if the INDEPENDENT MARKETER is a corporation, (iii) the INDEPENDENT MARKETER's license or the license of INDEPENDENT MARKETERS' principal agent is suspended or revoked by any regulatory authority, or (iv) the INDEPENDENT MARKETER invokes any form of federal bankruptcy jurisdiction or state jurisdiction for receivership, liquidation, or conservatorship.
                        </li>
                        <li>
                          Upon termination of this Agreement, the INDEPENDENT MARKETER shall immediately pay all sums due to EWAand shall deliver to Nu Era Benefits Agency all rate books; letters, records, supplies and any such related items connected with Nu Era Benefits Agency’s business.
                        </li>
                        <li>
                          If this Agreement is terminated for any reason, any monies that are due to the INDEPENDENT MARKETER shall be held by Nu Era Benefits Agency,for up to 90 days.  During that period, Nu Era Benefits Agency shall perform a final accounting and reconciliation, including chargebacks, and issue commissions due to INDEPENDENT MARKETER following such review.
                        </li>
                        <li>
                          Upon termination of employment by Nu Era Benefits Agency with cause or by Contractor with or without cause, Nu Era Benefits Agency will review licensure and appointment payments made on behalf of Contractor.  The Contractor agrees that Nu Era Benefits Agency shall recoup all monies paid by Nu Era Benefits Agency towards licensure and appointment of the Contractor in any state during the last twelve (12) months of Contractor’s period of employment.  Said monies may be recouped by withholding funds from monies paid to the Contractor in his or her last paycheck above minimum wage.  Further funds may be withheld from any future payment made to the Contractor for any purpose, until such time as all monies paid by Nu Era Benefits Agency under This Agreement have been repaid.  The Contractor shall be responsible for repayment of the entire amount, even if said amount exceeds Contractor’s final paycheck above minimum wage and/or other payment made to the Contractor for any purpose.
                        </li>
                        <li>
                          Nu Era Benefits Agency may, in its sole discretion, suspend or terminate this Agreement, temporarily or permanently revoking the INDEPENDENT MARKETER's authority to represent it, during any reasonable period of investigation, to determine whether conditions exist to warrant termination for cause.  The INDEPENDENT MARKETER shall reasonably cooperate with Nu Era Benefits Agency in any such investigation, to include producing necessary documents and providing any other information requested.
                        </li>
                        <li>
                          Nu Era Benefits Agency may, in its sole discretion, suspend or terminate this Agreement for violation by the INDEPENDENT MARKETER of any provision set forth in Paragraph Vl.B.1-6 as set forth herein above.
                        </li>
                      </ol>
                      <br />
                      <b>
                        <li>SUSPENSION</li>
                      </b>
                     
                      <p>
                        In the event INDEPENDENT MARKETER becomes the subject of a regulatory or other legal investigation or allegation, Nu Era Benefits Agency has the right to suspend INDEPENDENT MARKETER until such time as the issues are resolved or a final determination rendered.  Suspension can include suspension of INDEPENDENT MARKETER’S right to sell in one or more states during the suspension period.
                      </p>
                      <br />
                      <b>
                        <li>ASSIGNMENT</li>
                      </b>
                      <p>
                        The INDEPENDENT MARKETER may not assign this Agreement without the prior written consent of Nu Era Benefits Agency, which may not be unreasonably withheld.  Nu Era Benefits Agency may assign this Agreement at will, without the consent of the INDEPENDENT MARKETER.
                      </p>
                      <br />
                      <b>
                        <li>INDEBTEDNESS</li> </b
                      >
                     
                      <p>
                        Any debt the INDEPENDENT MARKETER owes Nu Era Benefits Agency shall be payable at Nu Era Benefits Agency’s home office.  Nu Era Benefits Agency may offset against any claim by the INDEPENDENT MARKETER for compensation hereunder any debt owed to Nu Era Benefits Agency by INDEPENDENT MARKETER then due or that may thereafter become due from the INDEPENDENT MARKETER, whether arising hereunder or otherwise, and such debt shall be a first lien on any such compensation.  Nu Era Benefits Agency shall have the right, at its discretion, to charge interest on any indebtedness due it by the INDEPENDENT MARKETER.  Interest shall be calculated from the time said indebtedness was incurred, at per annum rate equal to the prime commercial rate as charged by Bank of America (or its successor) from time to time; provided, however, that such rate shall not exceed the rate permitted to be charged by law.  Nu Era Benefits Agency shall have the right to determine to which indebtedness any payment made by the INDEPENDENT MARKETER, whether offset or otherwise, shall be applied.  The INDEPENDENT MARKETER shall pay all costs and expenses, including collection fees and/or reasonable attorney’s fees incurred by Nu Era Benefits Agency in collection of indebtedness hereunder.
                      </p>
                      <br />
                      <b>
                        <li>GENERAL</li> </b
                      >
                    
                      <ol type="a">
                        <li>
                          The Parties shall use their best efforts to keep in full force and affect all policies issued.  The Parties shall so conduct all actions as not to adversely affect the business, good standing, goodwill or reputation of Nu Era Benefits Agency and INDEPENDENT MARKETER.
                        </li>
                        <li>
                          The Parties agree to maintain all records and books as required by carrier guidelines, Nu Era Benefits Agency policies and procedures, federal, state or local law or regulation.
                        </li>
                        <li>
                          The Parties agree to comply with all carrier guidelines, Nu Era Benefits Agency policies and procedures, federal, state and/or local laws and/or regulations, and with all published bulletins, field letters, or any other written communications from EWAnow in force and such as may be hereafter accepted.
                        </li>
                        <li>
                          The INDEPENDENT MARKETER shall have no power or authority other than herein expressly granted and no other or greater powers shall be implied from the grant or denial of powers expressly mentioned herein.
                        </li>
                        <li>
                          The INDEPENDENT MARKETER shall have no claim and/or compensation for having introduced or brought to the attention of Nu Era Benefits Agency any business opportunity, except under separate written agreement with Nu Era Benefits Agency to pay such compensation, signed on behalf of by any principal and/or member of the board of directors of Nu Era Benefits Agency.
                        </li>
                        <li>
                          The forbearance or neglect of Nu Era Benefits Agency to insist upon strict compliance by the INDEPENDENT MARKETER with any of the provisions of this Agreement whether continuing or not, shall not be construed as a waiver of any of EWAs rights or privileges hereunder.  No waiver of any right or privilege arising from any default or failure of performance by the INDEPENDENT MARKETERT shall affect Nu Era Benefits Agency's rights or privileges in the event of a further default or failure of performance.
                        </li>
                        <li>
                          The Parties shall not reproduce any software or other material provided by either party to the other.  All such material shall be used exclusively in the performance of this Agreement and may not be used or distributed for any other purpose.
                        </li>
                        <li>
                          INDEPENDENT MARKETER shall notify Nu Era Benefits Agency immediately in writing if the any licensed agent, employee, associate, officer, director, principal or other representative of its business has been convicted of any felony, misdemeanor or any other lesser crime involving moral turpitude, including, but not limited to: theft, forgery, fraud, or any other crime involving dishonesty.
                        </li>
                        <li>
                          The INDEPENDENT MARKETER agrees to submit to any and all training determined to be necessary by Nu Era Benefits Agency, including, but not limited to, initial training upon execution of any INDEPENDENT MARKETER AGREEMENT and re-training upon any determination by Nu Era Benefits Agency that said INDEPENDENT MARKETER is in any way misrepresenting any of product sold on behalf of Nu Era Benefits Agency or is selling any product sold by Nu Era Benefits Agency in such a way as to damage Nu Era Benefits Agency's gEra 's discretion.  Nu Era Benefits Agency reserves the right to audit at any time and without prior notice, all sales tactics, all scripts and /or marketing materials, including but not limited to: marketing procedures and verification procedures utilized by INDEPENDENT MARKETER or any agent, representative, employee or any other person acting on behalf of the INDEPENDENT MARKETER and on behalf of any product offered by Nu Era Benefits Agency.
                        </li>
                      </ol>
                      <br />
                      
                      <b>
                        <li>INDEMNIFICATION</li> </b
                      >
                      <ol type="a">
                        <li>
                          INDEPENDENT MARKETER shall indemnify, defend, and hold harmless Nu Era Benefits Agency, its affiliates, officers, directors, members, shareholders, insurers, employees and parent corporations, from and against any and all third-party claims, suits, liabilities, losses, and damages of whatever nature, (including all reasonable costs, expenses and attorneys' fees) arising from or in connection with (a) any intentional or unintentional misrepresentation by INDEPENDENT MARKETER regarding an Nu Era Benefits Agency product/service that is the cause of such claim, (b) unauthorized transaction or (c) INDEPENDENT MARKETER's breach of the terms and conditions of this executed INDEPENDENT MARKETER Agreement, including prohibited marketing activities.
                        </li>
                      </ol>
                      <br />
                      <b>
                        <li>CONFIDENTIAL INFORMATION</li> </b
                      >
                      <ol type="a">
                        <li>
                          Confidential Information includes all individually identifiable health information and other information about a person that:
                          <ol class="sub-list">
                            <li>
                              a person provides to obtain coverage; or
                            </li>
                            <li>
                              results from a client transaction; or
                            </li>
                            <li>
                              is otherwise obtained in connection with providing coverage, such as: identities, names, addresses and ages of policyholders; types of policies; amounts of rates, policy renewals dates; client listings, claim information; any policyholder information subject to any privacy law; and information identified as confidential.
                            </li>
                          </ol>
                        </li>
                        <li>
                          Confidential Information also includes the following:
                          <ol class="sub-list">
                            <li>
                              any business plan or business plans and/or process or processes utilized by Nu Era Benefits Agency;
                            </li>
                            <li>
                              any customer and/or INDEPENDENT MARKETER lists utilized by Nu Era Benefits Agency;
                            </li>
                            <li>
                              any product or products developed and/or sold by Nu Era Benefits Agency;
                            </li>
                            <li>
                              any intellectual property utilized by Nu Era Benefits Agency, including but not limited to copyrightable material, computer software, trademark related materials such as names, logos, color schemes, trade dress related materials, or patentable processes or materials.
                            </li>
                          </ol>
                        </li>
                        <li>
                          The INDEPENDENT MARKETER agrees that it shall:
                          <ol class="sub-list">
                            <li>
                              use Nu Era Benefits Agency's Confidential Information only for the purpose for which it was disclosed and only to carry out the provisions of this Agreement;
                            </li>
                            <li>
                              not disclose Nu Era Benefits Agency's Confidential Information to third parties unless necessary to meet its obligations under this Agreement, and then only to a third party similarly bound by the same privacy standards and agreements;
                            </li>
                            <li>
                              continue to treat Nu Era Benefits Agency's Confidential Information in this manner even after termination of this Agreement; and
                            </li>
                            <li>
                              comply with all applicable privacy laws and regulations; and
                            </li>
                            <li>
                              comply with all insurance carriers' and the Party's policies and procedures regarding Confidential Information.
                            </li>
                          </ol>
                        </li>
                        <li>
                          INDEPENDENT MARKETER further agrees that Nu Era Benefits Agency has furnished and is furnishing certain Confidential Information and Trade Secret Information to the INDEPENDENT MARKETER.  The term "Confidential Information" shall mean all information that Nu Era Benefits Agency has furnished to the INDEPENDENT MARKETER.  The term "Trade Secret Information" shall mean all information owned or claimed to be owned by Nu Era Benefits Agency, including but not limited to customer information, marketing information, formula, pattern, compilation, program, device, method, technique, or process that:
                          <ol class="sub-list">
                            <li>
                              derives independent economic value, actual or potential, from not being generally known to, and not being readily ascertainable by proper means by, other persons who can obtain economic value from its disclosure or use; and
                            </li>
                            <li>
                              is the subject of efforts that are reasonable under the circumstances to maintain its secrecy.  Nu Era Benefits Agency’s Confidential Information and Trade Secret Information includes a description of the unique manner in which Nu Era Benefits Agency performs its business operations and may also consist of and is not limited to, computer software, customer lists and agreements, provider lists and agreements, INDEPENDENT MARKETER and/or agency lists, employee lists, marketing strategies, access and referral agreements, internal payment processing and administrative procedures and demographic and other data related to the business of Nu Era Benefits Agency.
                            </li>
                          </ol>
                        </li>
                        <li>
                          INDEPENDENT MARKETER agrees that it will keep the Confidential Information and Trade Secret Information private and that the Confidential Information and Trade Secret Information will not, without the prior written consent of Nu Era Benefits Agency, be disclosed by INDEPENDENT MARKETER or by its officers, directors, shareholders, partners, employees, affiliates, agents, investors, consultants, contractors or representatives (collectively "Representatives") in any manner whatsoever, in whole or in part, and shall not be used by the Parties or by their Representatives.  Moreover, INDEPENDENT MARKETER agrees to transmit the Confidential Information and Trade Secret Information only to such of its representatives who in writing, agree to be bound by the terms hereof as if a party hereto.  In any event, the INDEPENDENT MARKETER shall be fully liable for any breach of this Agreement by it or its Representatives and agrees, at its sole expense, to take all reasonable measures (including, but not limited to, court proceedings) to restrain its representatives from prohibited or unauthorized disclosure or use of the Confidential Information and Trade Secret Information originating from Nu Era Benefits Agency
                        </li>
                        <li>
                          The INDEPENDENT MARKETER agrees that neither it nor its Representatives shall use the Confidential Information and Trade Secret Information provided by Nu Era Benefits Agency to develop any product or service, which is the same as or similar to any product or service sold on behalf of Nu Era Benefits Agency.  The INDEPENDENT MARKETER understands and agrees that any payment mechanism, any version of the computer network and/or any lead management system utilized by Nu Era Benefits Agency is unique and agrees that it will not develop for its own use, nor divulge in any manner whatsoever the methods Nu Era Benefits Agency utilizes to anyone other than the INDEPENDENT MARKETER.  INDEPENDENT MARKETER understands and agrees that the relationships between Nu Era Benefits Agency, its customers, agencies and/or INDEPENDENT MARKETERs are unique, and agrees to not contact those customers, agencies and/or INDEPENDENT MARKETERs for commercial purposes other than on behalf of Nu Era Benefits Agency for a period of twenty-four months upon termination of the this Agreement between the parties.  INDEPENDENT MARKETER further agrees that if INDEPENDENT MARKETER violates this Paragraph, then Nu Era Benefits Agency has no remedy at law and may pursue its equitable remedies including specific performance, injunctions and restraining orders in any court of competent jurisdiction.
                        </li>
                      </ol>
                      <br />
                      <b>
                        <li>NON-SOLICITATION</li> </b
                      >
                      <ol type="a">
                        <li>
                          INDEPENDENT MARKETER shall not induce or attempt to induce any customers, employees, licensed INDEPENDENT MARKETERs, representatives, agencies of record and/or any INDEPENDENT MARKETERs of record to discontinue their association with Nu Era Benefits Agency.
                        </li>
                        <li>
                          Nu Era Benefits Agency shall not induce or attempt to induce any customers, employees, INDEPENDENT MARKETERs and/or representatives, agencies of record and/or INDEPENDENT MARKETERS of record to discontinue their association with INDEPENDENT MARKETER.
                        </li>
                      </ol>
                      <br />
                      <b>
                      <li>APPROVAL OF SOLICITATIONS</li>
                      </b>
                      <p>
                        The INDEPENDENT MARKETER shall not publish or disseminate any type of solicitations, scripts, forms, advertisements or material in any media concerning Nu Era Benefits Agency or any of its contracted companies without the prior written consent of both the Carrier and Nu Era Benefits Agency  INDEPENDENT MARKETER shall in no way replicate Nu Era Benefits Agency's website without Nu Era Benefits Agency's express permission
                      </p>
                      <br />
                      <b>
                        <li>JURISDICTION AND VENUE.</li>
                      </b>
                      <ol type="a">
                        <li>
                          This Agreement and the relationship of the parties shall be governed by the laws of the State of Florida applicable to agreements executed and performed within the State of Florida and without giving effect to any statutes or rules relating to the conflict of laws.  The Parties agree and acknowledge that in the negotiating and executing of this agreement and in the performance of this Agreement, they are purposefully availing themselves of the benefits and laws of the State of Florida as to any dispute arising out of or related to the inception or performance of this Agreement.  The Parties hereby waive their right to contest the exercise of personal jurisdiction over them in the State of Florida  The Parties further agree that exclusive venue shall lie in Florida County, Florida. Nu Era Benefits Agency may pursue its equitable remedies, including specific performance, injunctions and restraining orders in any court of competent jurisdiction.
                        </li>
                        <li>
                          Both parties shall use best efforts to resolve disputes in an amicable manner for a period of ten (10) days.  The Parties agree that any dispute arising out of or related in any way to the solicitation, negotiation, inception or performance of this Agreement (whether the dispute is couched in terms of contractual, statutory, or common law grounds) shall be exclusively resolved and construed in accordance with Commercial Arbitration Rules of the American Arbitration Association pursuant to the laws of the State of Florida governing arbitration.  For any disputes not resolved amicably, venue shall be in Broward County, Florida and any judgment upon the award rendered by the arbitrator(s) may be entered in any court having competent jurisdiction thereof.
                        </li>
                      </ol>
                      <br />
                      <b>
                      <li>WAIVER / MODIFICATION</li>
                      </b>
                      <p>
                        No waiver or modification of this Agreement shall be effective unless in writing, expressing by its terms an intention to modify this Agreement, and signed by duly authorized representatives of all parties hereto.
                      </p>
                      <br />
                      <b>
                      <li>SUPERVISION / RESPONSIBILITY </li>
                      </b>
                      <p>
                        The Parties shall be held harmless from any losses or expenses on the account of the acts or omissions of the other party or any employee, associate, officer, director, principal or any other representative.
                      </p>
                      <br />

                      <b>
                      <li>COMPLAINTS</li>
                      </b>
                      <p>
                        The INDEPENDENT MARKETER shall document and report within twenty four (24) hours of occurrence regulatory complaints relating to Nu Era Benefits Agency and shall provide any response thereto.  The Parties agree to fully cooperate with each other in the investigation and resolution of such complaints.
                      </p>
                      <br />

                      <b>
                      <li>SEVERABILITY</li>
                      </b>
                      <p>
                        In the event that any paragraph, subparagraph or provision of this Agreement shall be determined to be contrary to governing law or otherwise unenforceable, all remaining portions of this Agreement shall be enforced to the maximum extent permitted by law.
                      </p>
                      <br />

                      <b>
                      <li>ENTlRE AGREEMENT</li>
                      </b>
                      <p>
                        This Agreement and the Schedules, Attachments or Addendums thereof, represents the complete agreement of the parties concerning the subject matter hereof, and all prior or contemporaneous negotiations, promises or agreements are merged herewith.
                      </p>
                      <br />

                      <b>
                      <li>BINDING EFFECT</li>
                      </b>
                      <p>
                        This Agreement shall inure to the benefit of and be binding upon the parties hereto, their successors and assigns.
                      </p>
                      <br />

                      <b>
                      <li>RELATIONSHIP OF PARTIES</li>
                      </b>
                      <p>
                        Nothing contained herein shall be construed to create the relationship of employer and employee between the parties.  The INDEPENDENT MARKETER is an independent contractor.
                      </p>
                      <br />

                      <b>
                      <li>CAPTIONS</li>
                      </b>
                      <p>
                        The captions and headings of paragraphs and subparagraphs are inserted for convenience of reference only and are not a part hereof and shall not affect the construction or interpretation of any provision herein this Agreement.
                      </p>
                      <br />

                      <b>
                      <li>COUNTERPARTS</li>
                      </b>
                      <p>
                        This Agreement may be executed simultaneously in several counterparts, each of which shall be original, and all of which shall constitute but one and the same instrument.  A facsimile signature shall be considered the same as an original signature.
                      </p>
                      <br />

                      <b>
                      <li>NUMBER AND GENDER</li>
                      </b>
                      <p>
                        Whenever required for proper interpretation of this Agreement, the singular number shall include the plural, the plural the singular, and the use of any gender shall include all genders.
                      </p>
                      <br />

                      <b>
                      <li>CONSTRUANCE</li>
                      </b>
                      <p>
                        This Agreement has been negotiated at arm's length by the parties and shall not be construed against the drafting party.
                      </p>
                      <br />
                      <p class="initial">
                        NOW, THEREFORE, IN WITNESS WHEREOF, the parties hereto have executed this agreement this 
                        <input 
                          type="text" 
                          name="" 
                          id="" 
                          :readonly="formFields.agreement_day.read_only"
                          v-model="formFields.agreement_day.value" 
                          @input="resetErrors('agreement_day')"
                        >
                        <small class="error_message" v-if="formErrorFlag == true">{{formErrors['agreement_day']}}</small>
                        day of 
                        <select 
                          :disabled="formFields.agreement_month.read_only"
                          v-model="formFields.agreement_month.value"
                        >
                          <option v-for="(month , i) in computedMonths" :key="i" :value="month.value">{{ month.name }}</option>
                        </select>
                        <small class="error_message" v-if="formErrorFlag == true">{{formErrors['agreement_month']}}</small>
                        , {{currentDate.year }}
                      </p>
                    </ol>
                    </div
                >
          <div>
            <div>
              <h3 class="mt-3 mb-0"
                >Signature
             </h3
              >
            </div>
            <div class="agreement_signature">
                    <span class="sign_container">
                      <span class="signature_block">
                        <p class="left">
                          <span class="sign">
                            <p>Signature of Independent Marketer </p>
                            <span class="signature-canvas-wrap">
                            <canvas id="repSignature" @sign="getSign" class="signature"></canvas>
                            </span>
                            <button class="clear" type="button" name="button" @click="clear">Clear</button>
                            <small class="error_message" v-if="formErrorFlag == true">{{formErrors['agreement_signature_message']}}</small>
                          </span>

                          <span>
                          <p>Print Name</p>
                          <input type="text"
                              name="rep_name" 
                              class="text-name screenshot-input"
                              v-model="formFields.rep_name.value"
                              @input="resetErrors('contract_name')"
                              required
                          />
                          </span>
                        <small class="error_message" v-if="formErrorFlag == true">{{formErrors['contract_name']}}</small>
                        </p>
                        <p class="right">                          
                          <span class="sign">

                           <p> Association Officer Signature</p>
                           <span class="signature-canvas-wrap">
                           <canvas id="signature" class="signature"></canvas>
                           </span>
                              </span><br>
                          <span><p class="associate-name-gap mb-2 pt-1">Print Name and Title</p>
                          
                            <input type="text"
                              name="officer_name"
                              class="screenshot-input"
                              v-model="formFields.officer_name.value"
                              :readonly="formFields.officer_name.read_only"
                            />
                          </span>
                        </p>
                      </span>
                    </span>
            </div>
          </div>
        </div>

        <div class="button_container">
           <button class="back" type="button" name="button" @click="navigatePrevious">Back</button>
          <div class="button">
            <!-- <router-link :to="{ name: 'ContractCommissionSheet' }"> -->
              <button :disabled="isActive" class="next" @click="saveAgreementSignatureInfo()">Done</button>
              <!-- </router-link> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import AgentInfo from "../common/AgentInfo.vue";
  import SignaturePad from 'signature_pad';
  import ContractFormSidebar from '../partial/ContractFormSidebar.vue';
  import axios from 'axios';
  import html2canvas from 'html2canvas';
  import helper from "@/resource/Helper";
  import * as  utlisHelper from '../../utlis/helper.js';
  import moment from 'moment';
  export default {
    name: "MyComponent",
    components: {AgentInfo, ContractFormSidebar },
    data() {
      return {
        tempId: '',
        isVisible: false,
        isNotVisible: true,
        isActive: false,
        sig_image:'',
        formFields:{
          rep: {
              value: '',
              required: true,
              read_only: false,
          },
          initial: {
              value: '',
              required: true,
              read_only: false,
          },
          rep_name: {
              value: '',
              required: true,
              read_only: false,
          },
          officer_name: {
              value: '',
              required: true,
              read_only: true,
          },
          officer_signature: {
              value: '',
              required: true,
              read_only: true,
          },
          agreement_signature: {
              value: '',
              required: true,
              read_only: true,
          },
          tab_info: {
              value: '',
              required: true,
              read_only: true,
          },
          marketer_address: {
              value: '',
              required: true,
              read_only: false,
          },
          aggrement_eff_date:{
            value:'',
            required:true,
            read_only:false
          },
          agreement_day:{
            value:'',
            required:true,
            read_only:false
          },
          agreement_month:{
            value:'',
            required:true,
            read_only:false
          }
        },
        signaturePad: null,
        signaturePad1: null,
        signatureError : false,
        formErrorFlag: false,
        formErrors: [],
        currentDate:{
          year:''
        },
        contractId:'',
      };
    },
    mounted(){
      let app = this;
      app.tempId = window.localStorage.getItem('tempId').split(',');
      app.contractType= window.localStorage.getItem('contractType').split(',');
      app.contractId= window.localStorage.getItem('contract_id').split(',');
      app.getAgreementInfo();
      let canvas = document.querySelector('#signature');
      app.signaturePad = new SignaturePad(canvas, {
        onEnd: () => {
          app.signaturePad.toDataURL();
        }
      });           
      let canvas1 = document.querySelector('#repSignature');
      app.signaturePad1 = new SignaturePad(canvas1, {
        backgroundColor: "rgba(255, 255, 255, 0)",
        onEnd: () => {
          app.signaturePad1.toDataURL();
        }
      }); 
          
      app.signaturePad.off();
      var ratio =  Math.max(window.devicePixelRatio || 0, 0)
      canvas.width = canvas.offsetWidth * ratio
      canvas.height = canvas.offsetHeight * ratio
      canvas.getContext("2d").scale(ratio, ratio)
      canvas1.width = canvas1.offsetWidth * ratio
      canvas1.height = canvas1.offsetHeight * ratio
      canvas1.getContext("2d").scale(ratio, ratio)
    },
    methods:{
      
      getAgreementInfo(){
        let loader = this.$loading.show();
        let app = this;
        axios.get(process.env.VUE_APP_CORENROLL_SYSTEM+'/get-form-data-agreement-info?', {
        params: {
            tempid: app.tempId,
        }
        })
        .then(function (response) {
            let fetchedData = [];
            if (response.data.status == 'success') {
                for(var i in response.data.data.result) {
                    fetchedData.push(response.data.data.result[i]);
                }
                fetchedData.forEach(function(item) {
                  console.log(item);
                    app.formFields[item.field_name].value = item.value;
                    app.formFields[item.field_name].read_only = item.read_only;
                });
                console.log('data set success');
                app.setFormDateValues();
            }
            app.loadSignature();
            })
            .catch(function (error) {
              console.error(error);
              if(error.response.data.message == 'Form completed.'){
                      window.location = '/contract-form/contract_message/completed';
                  }else if(error.response.data.message == 'Agent does not exist.'){
                      window.location = '/contract-form/contract_message/not_found';
                  } else {
                    window.location = '/contract-form/contract_message/error';
                  }
          }).finally(() => {
          loader.hide();
        });              
      },
      loadSignature(){
        let app = this;
        var canvas1 = document.getElementById('signature'),
        context = canvas1.getContext('2d');
        app.make_base(context);
        
      },
      
      make_base(context){
        let app = this;
        var base_image = new Image();
        base_image.src = app.formFields.officer_signature.value;
        base_image.onload = function(){
            context.clearRect(0, 0, 435, 180);
            context.drawImage(base_image, 0, 0, 435, 180);
        }
      },
      clear() {
          let app = this;
          app.signaturePad1.clear();
          app.signatureError = false;
          console.log('cleared');
      },
      getSign(sign = "") {
        this.formFields.agreement_signature.value = sign;
        console.log(sign);
      },
      setFormDateValues(){
        this.currentDate.year = moment().format('YYYY');
        this.formFields.agreement_day.value = moment().format('D');
        this.formFields.agreement_month.value = moment().format('M');
        this.formFields.aggrement_eff_date.value = moment().format('MM/DD/YYYY');
        console.log('here form date set')
      },
      resetErrors(field){
        if(field){
          this.formErrors[field] = '';
        }else{
          this.formErrors = [];
          this.formErrorFlag = false;
        }
      },
      handleValidation(){
        const requiredMessage = "This Field is required";
        if(!this.formFields.initial.value){
          this.formErrorFlag = true;
          this.formErrors['initial'] = requiredMessage;
          return false;
        }
        if(!this.formFields.marketer_address.value){
          this.formErrorFlag = true;
          this.formErrors['marketer_address'] = requiredMessage;
          return false;
        }
        if(!this.formFields.aggrement_eff_date.value){
          this.formErrorFlag = true;
          this.formErrors['aggrement_eff_date'] = requiredMessage;
          return false;
        }
        if(!this.formFields.agreement_day.value){
          this.formErrorFlag = true;
          this.formErrors['agreement_day'] = requiredMessage;
          return false;
        }
        if(!this.formFields.agreement_month.value){
          this.formErrorFlag = true;
          this.formErrors['agreement_month'] = requiredMessage;
          return false;
        }
        if(this.signaturePad1.isEmpty()){
          this.formErrorFlag = true;
          this.isActive = false;
          this.formErrors['agreement_signature_message'] = "The agreement signature field is required";
          return false;
        }
        if(!this.formFields.rep_name.value){
          this.formErrorFlag = true;
          this.formErrors['contract_name'] = requiredMessage;
          return false;
        }
        this.resetErrors();
        return true;
      },
      saveAgreementSignatureInfo() {
        let loader = this.$loading.show();
        let app = this;
        app.isNotVisible = true;
        app.isVisible = false;
        app.formErrorFlag = false;
        app.formErrors    = [];
        const isValid = this.handleValidation();
        console.log('here', isValid);
        if(!isValid){
          helper.infoMessage(this, "error", "Please check all form fields");
          loader.hide();
          return false;
        }
        const el = app.$refs.save;
        (async () => {
            app.saveScreenShot((await html2canvas(el, {
              scrollX: 0,
              scrollY: -window.scrollY,
              windowWidth: document.documentElement.scrollWidth,
              windowHeight: document.documentElement.scrollHeight
            })).toDataURL('image/png'), 'agreement');
        })();
        let params = {
          tempid:               app.tempId,
          contract_name:        app.formFields.rep_name.value,
          marketing_initial:    app.formFields.initial.value,
          agreement_name:       app.formFields.rep_name.value,
          agreement_signature:  app.signaturePad1.toDataURL('image/png'),
          marketer_address:     app.formFields.marketer_address.value,
          aggrement_eff_date :  app.formFields.aggrement_eff_date.value,
          agreement_day:        app.formFields.agreement_day.value,
          agreement_month:      app.formFields.agreement_month.value
        };
        //discard null values
        for (const key of Object.keys(params)) {
          if (params[key] === null) {
              delete params[key];
          }
        }
        axios.post(process.env.VUE_APP_CORENROLL_SYSTEM+'/save-agreement-and-signature-information', params)
        .then(function (response) {
            if (response.data.status == 'success') {
              app.saveContractInfo();
            }
        })
        .catch(function (error) {
            if (error.response.data.status == 'error') {
                  if(error.response.data.data[0].target_element == "contract_name" ||error.response.data.data[0].target_element == "marketing_initial" ||error.response.data.data[0].target_element == "agreement_check1" ||error.response.data.data[0].target_element == "agreement_check2"){
                        app.isNotVisible = false;
                        app.isVisible = true;
                  }
                  setTimeout(() => { 
                    if(error.response.data.data[0].target_element == "contract_name"){
                      app.$refs.rep.focus();
                    }                
                    if(error.response.data.data[0].target_element == "marketing_initial"){
                      app.$refs.initial.focus();
                    }                
                    if(error.response.data.data[0].target_element == "agreement_check1"){
                      app.$refs.checkbox1.focus();
                    }                
                    if(error.response.data.data[0].target_element == "agreement_check2"){
                      app.$refs.checkbox2.focus();
                    }
                  }, 2000);
                                      
                  error.response.data.data.forEach(function(item) {
                      app.isActive = false;
                      app.formErrorFlag = true;
                      app.formErrors[item.target_element+'_message'] = item.error_message;
                  });                    
            }
        }).finally(() => {
          loader.hide();
        });
      },
      saveContractInfo(){
        let loader = this.$loading.show();
        let app = this;
        let params = {
          tempid:app.tempId,
          contract_type:app.contractType,
          contract_id:app.contractId,
        };
        axios.post(process.env.VUE_APP_CORENROLL_SYSTEM+'/save-contract-data', params)
        .then(function (response) {
            if (response.data.status == 'success') {
              app.startPDFJob(app.contractId,app.tempId);
            }else {
              //  window.location = '/contract-form/contract_message/error';
              // console.log("error");
            }
        })
        .catch(function (error) {
           console.log("ERROR SAVING CONTRACT INFO!!!");
           console.log(error);
        }).finally(() => {
          loader.hide();
        });
      },
      navigatePrevious() {
          //Update APIs
          //Navigate to next page
          this.$router.push("commission_sheet");
          window.localStorage.setItem('sheet_complete', 'incomplete');
       
      },
      saveScreenShot (image, name) {
        let app = this;
        let loader = this.$loading.show();
        let data = {
            "agent_id" : window.localStorage.getItem('agentId'),
            "contract_type" : app.contractType,
            "image" : image,
            "name" : name,
            "tempid" : app.tempId,
        };
        let config = {
            method: 'post',
            url: process.env.VUE_APP_CORENROLL_SYSTEM+'/save-contract-screenshot',
            headers: { },
            data : data
        };
        axios(config)
            .then(function (response) {
                if (response.data.status == 'success') {
                    console.log('screenshot saved');
                }
            })
            .catch(function (error) {
                console.log('screenshot not saved');
            }).finally(() => {
          loader.hide();
        });
      },
      scrollTop(){
          window.scrollTo(0,0);
      },
      async startPDFJob(contract_id, tempId) {
          console.log("startPDFJob");
          console.log("contract_id", contract_id);
          console.log("tempId", tempId);
          let app = this;
          const formData = new FormData();
          contract_id.forEach(id => {
                  formData.append('contract_id[]', id);
              });
          tempId.forEach(id => {
                  formData.append('tempid[]', id);
              });
          try {
              const response = await axios.post(
                  process.env.VUE_APP_CORENROLL_SYSTEM + "/generate-contract-pdf",
                  formData
              );
              const { message } = response.data;
              const encodedContractType = utlisHelper.encodeValueForUrl(app.contractType);
              const encodedTempId = utlisHelper.encodeValueForUrl(app.tempId);
              const encodedContractId = utlisHelper.encodeValueForUrl(app.contractId);
              // Display success message
              helper.infoMessage(this, 'success', message);
              // Wait for a brief moment before redirecting
              setTimeout(() => {
                  let url = `/contractTemplate/${encodedContractType}/${encodedTempId}/${encodedContractId}`;
                  this.clearContractLocalStorageKeys().
                  then(() => {
                    window.location = url;
                  });
                  // window.localStorage.setItem('agreement_complete', 'complete');
              }, 2000); 

          } catch (error) {
              helper.infoMessage(this, 'error', 'Something went wrong');
          }
      },
      clearContractLocalStorageKeys() {
        return new Promise((resolve, reject) => {
          try {
            // Clear all localStorage keys
            window.localStorage.clear();
            resolve();
          } catch (error) {
            console.error('Error clearing localStorage keys:', error);
            reject(error);
          }
        });
      }
    },
    computed:{
      computedMonths(){
        return [
          {name:'Jan', value:'1'},
          {name:'Feb', value:'2'},
          {name:'Mar', value:'3'},
          {name:'Apr', value:'4'},
          {name:'May', value:'5'},
          {name:'Jun', value:'6'},
          {name:'July', value:'7'},
          {name:'Aug' , value:'8'},
          {name:'Sep' , value:'9'},
          {name:'Oct' , value:'10'},
          {name:'Nov', value:'11'},
          {name:'Dec' , value:'12'}
        ]
      }
    }
  };
</script>

<style src="../../assets/css/contract_form/agreement.css" scoped>
</style>

<style scoped>
/* Ensure input fields are visible in screenshots */
.screenshot-input {
  background-color: white !important;
  border: 1px solid #ccc !important;
  color: #333 !important;
  padding: 2px 5px !important;
  font-size: 14px !important;
  min-height: 20px !important;
}

.screenshot-input:readonly {
  background-color: #f9f9f9 !important;
  color: #666 !important;
}
</style>